export enum AttendanceCodeInSchool {
  Outside,
  OnPremises,
}

export enum AttendanceCodeIsPresent {
  Absent,
  Present,
}

export enum AttendanceCodeAction {
  NoAction = 'no_action',
  NotifyParents = 'notify_parents',
  RequestJustification = 'request_justification',
}

export const ATTENDANCE_CODE_MAX_LENGTH = 1;
